import { QueryClient, useQueryClient } from "@tanstack/react-query";

export class SprintQueryClient extends QueryClient {}

export const useSprintQueryClient = useQueryClient;
